import { getStages } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Stage } from "../types/stageTypes";
// import { dummyStages } from "@/data/dummyData";

export default function useStages(callBack?: (data: Stage[]) => void) {
  const query = useQuery<Stage[]>({
    queryKey: ["stages"],
    queryFn: async () => {
      const res = await axiosInstance.get(getStages);

      return res.data.stages;
    },
  });

  useEffect(() => {
    if (query.data && callBack) {
      callBack(query.data);
    }
  }, [query.data]);

  return {
    stages: query.data,
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
